<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Create New Siswa
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form v-on:submit.prevent="save">
                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 1 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan Siswa BTA
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_formulir']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">No. Kepesertaan</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.student.identity" class="form-control form-control-sm" required />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Tanggal Daftar</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <datepicker v-model="form.student.registeredAt" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm" required></datepicker>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-if="profile.isAdmin">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.branchID" class="form-control form-control-sm" required>
                                                <option disabled value="">Pilih Cabang...</option>
                                                <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Program</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="branchProgramID" class="form-control form-control-sm">
                                                <option value="">Pilih Program...</option>
                                                <option v-for="branchProgram in branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Semester 1</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.patternID" class="form-control form-control-sm">
                                                <option value="">Pilih Pola...</option>
                                                <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Semester 1</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.branchClassID" class="form-control form-control-sm">
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="branchClass in branchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Semester 2 </label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.secondPatternID" class="form-control form-control-sm">
                                                <option value="">Pilih Pola...</option>
                                                <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Semester 2 </label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.secondBranchClassID" class="form-control form-control-sm">
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="branchClass in secondBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Intensif UTBK</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.thirdPatternID" class="form-control form-control-sm">
                                                <option value="">Pilih Pola...</option>
                                                <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Intensif UTBK</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.thirdBranchClassID" class="form-control form-control-sm">
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="branchClass in thirdBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Intensif Mandiri </label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.fourthPatternID" class="form-control form-control-sm">
                                                <option value="">Pilih Pola...</option>
                                                <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Intensif Mandiri </label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.fourthBranchClassID" class="form-control form-control-sm">
                                                <option value="">Pilih Kelas...</option>
                                                <option v-for="branchClass in fourthBranchClasses" v-bind:value="branchClass.id" v-bind:key="branchClass.id">{{ branchClass.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sesi Intensif</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.intensiveScheduleID" class="form-control form-control-sm">
                                                <option value="">Pilih Sesi Intensif...</option>
                                                <option v-for="intensive in intensives" v-bind:value="intensive.id" v-bind:key="intensive.id">{{ intensive.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--<div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kelas Intensif</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.intensiveClassID" class="form-control form-control-sm">
                                                <option value="">Pilih Kelas Intensif...</option>
                                                <option v-for="intensiveClass in intensiveClasses" v-bind:value="intensiveClass.id" v-bind:key="intensiveClass.id">{{ intensiveClass.name }}</option>
                                            </select>
                                        </div>
                                    </div>-->
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Ruang Placement Test</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.verified.placement" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Rencana Pola Hari</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.verified.payment" class="form-control form-control-sm" />
                                        </div>
                                    </div>
				    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Pembelajaran</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="form-check form-check-inline py-1" v-for="learn in ['Online', 'Offline']">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.profile.pembelajaran" type="radio" class="custom-control-input" v-bind:value="learn" v-bind:id="'input-pembelajaran-' + learn" />
                                                    <label class="custom-control-label h4" v-bind:for="'input-pembelajaran-' + learn">{{ learn }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Keterangan Pembayaran</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.verified.paymentNote" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Ukuran Jaket Khusus Kelas 12 & Alumni</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile.ukuran_jaket" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Diterima Di Jalur</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile.diterima_jalur" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Diterima Di Sekolah/Univ</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile.diterima_univ" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['diterima_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="n in 3">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sekolah/ Universitas Impian {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['sekolah_impian_' + n]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 2 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Profil Siswa
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12">
                                            <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                                <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                                    <i class="fa fa-upload"></i>
                                                </div>
                                                <input ref="upload" type="file" class="form-control" v-on:change="preview" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Lengkap</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model.trim="form.student.name" @input="form.student.name = $event.target.value.toUpperCase().trimStart()" class="form-control form-control-sm" required />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Alamat Email</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model.trim="form.student.email" @input="form.student.email = $event.target.value.toLowerCase().trimStart()" type="email" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Asal Sekolah</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <multiselect v-model="school" v-on:select="school => form.student.schoolID = school.id" v-bind:options="schools" v-bind:allow-empty="false" tag-placeholder="" select-label="" label="name" track-by="id" placeholder="Asal Sekolah" class="form-control form-control-sm" required>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi Sekolah</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.gradeID" class="form-control form-control-sm" required>
                                                <option disabled value="">Pilih Prodi...</option>
                                                <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi BTA</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.btaGradeID" class="form-control form-control-sm" required>
                                                <option disabled value="">Pilih Prodi BTA...</option>
                                                <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Jenis Kelamin</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                    <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 3 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Orang Tua Siswa
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model.trim="form.profile[attribute]" :type="attribute.includes('email') ? 'email' : 'text'" @input="form.profile[attribute] = attribute.includes('nama') ? $event.target.value.toUpperCase().trimStart() : attribute.includes('email') ? $event.target.value.toLowerCase().trimStart() : $event.target.value.trimStart()" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Section 4 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SBMPTN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SBMPTN_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <template v-for="n in 3">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Univ {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SBMPTN_univ_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SBMPTN_prodi_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 5 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SNMPTN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SNMPTN_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <template v-for="n in 3">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Univ {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SNMPTN_univ_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['SNMPTN_prodi_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <!-- Section 6 
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan PPKB
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_nomor', 'PPKB_univ', 'PPKB_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>-->

                            <!-- Section 7 
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan IUP UGM
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['IUP_nomor', 'IUP_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 8 
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan Talent Scouting
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['TS_nomor', 'TS_univ', 'TS_prodi']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 9 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan Ujian Mandiri
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <template v-for="n in 3">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nomor Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_nomor']" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Universitas Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_univ']" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi Ujian Mandiri {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['Mandiri_' + n + '_prodi']" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 10 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepesertaan SIMAK UI
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['SIMAK_nomor']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="n in 7">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['SIMAK_prodi_' + n]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 class="font-weight-bold text-danger">*Wajib Diisi</h4>
                    <div class="pt-3 mb-5">
                        <button type="submit" class="btn btn-danger btn-sm px-5">
                            Save
                        </button>
                        <router-link v-bind:to="{ name: 'student/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                            Cancel
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { semesters } from '@/params.js';
    
    export default {
        name: "StudentAdd",
        components: {
            Multiselect,
            Datepicker
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            profile() {
                this.fetchBranches();
            },
            'form.student.branchID'(branchID) {
                if (branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: branchID}}).then(response => {
                        this.branchPrograms = response.data.data;
                    });
                } else {
                    this.branchPrograms = [];
                }
                this.branchProgramID = '';
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.all([
                        this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}),
                        this.axios.get(process.env.API_URL + '/intensive-schedule', {params: {branchProgramID: branchProgramID}})
                    ]).then(this.axios.spread(function (responsePattern, responseIntensive) {
                        this.patterns = responsePattern.data.data;
                        this.intensives = responseIntensive.data.data;
                    }.bind(this)));
                } else {
                    this.patterns = [];
                    this.intensives = [];
                }
                this.form.verified.patternID = '';
                this.form.verified.intensiveScheduleID = '';
                this.form.verified.intensiveClassID = '';
            },
            'form.verified.patternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.branchClasses = response.data.data;
                    });
                } else {
                    this.branchClasses = [];
                }
                this.form.verified.branchClassID = '';
            },
            'form.verified.secondPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.secondBranchClasses = response.data.data;
                    });
                } else {
                    this.secondBranchClasses = [];
                }
                this.form.verified.secondBranchClassID = '';
            },
            'form.verified.thirdPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.thirdBranchClasses = response.data.data;
                    });
                } else {
                    this.thirdBranchClasses = [];
                }
                this.form.verified.thirdBranchClassID = '';
            },
            'form.verified.fourthPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.fourthBranchClasses = response.data.data;
                    });
                } else {
                    this.fourthBranchClasses = [];
                }
                this.form.verified.fourthBranchClassID = '';
            },
            'form.verified.intensiveScheduleID'(intensiveScheduleID) {
                if (intensiveScheduleID) {
                    this.axios.get(process.env.API_URL + '/intensive-class', {params: {intensiveScheduleID: intensiveScheduleID}}).then(response => {
                        this.intensiveClasses = response.data.data;
                    });
                } else {
                    this.intensiveClasses = [];
                }
                this.form.verified.intensiveClassID = '';
            }
        },
        data() {
            return {
                form: {
                    student: {
                        name: '', identity: '', gradeID: '', btaGradeID: '', branchID: '', schoolID: '', email: '', image: ''
                    },
                    profile: {
                        nomor_formulir: '', tempat_lahir: '', tanggal_lahir: '', jenis_kelamin: 'Laki-laki', alamat_rumah: '', kode_pos: '', nomor_telp_rumah: '', nomor_hp_siswa: '',
                        nama_ayah: '', nomor_hp_ayah: '', pekerjaan_ayah: '', email_ayah: '', nama_ibu: '', nomor_hp_ibu: '', pekerjaan_ibu: '', email_ibu: '',
                        ukuran_jaket: '', diterima_jalur: '', diterima_univ: '', diterima_prodi: '',
                        SNMPTN_nomor: '', SNMPTN_univ_1: '', SNMPTN_prodi_1: '', SNMPTN_univ_2: '', SNMPTN_prodi_2: '', SNMPTN_univ_3: '', SNMPTN_prodi_3: '',
                        SBMPTN_nomor: '', SBMPTN_univ_1: '', SBMPTN_prodi_1: '', SBMPTN_univ_2: '', SBMPTN_prodi_2: '', SBMPTN_univ_3: '', SBMPTN_prodi_3: '',
                        PPKB_nomor: '', PPKB_univ: '', PPKB_prodi: '',
                        TS_nomor: '', TS_univ: '', TS_prodi: '',
                        IUP_nomor: '', IUP_prodi: '',
                        SIMAK_nomor: '', SIMAK_prodi_1: '', SIMAK_prodi_2: '', SIMAK_prodi_3: '', SIMAK_prodi_4: '', SIMAK_prodi_5: '', SIMAK_prodi_6: '', SIMAK_prodi_7: '',
                        Mandiri_1_nomor: '', Mandiri_1_univ: '', Mandiri_1_prodi: '', Mandiri_2_nomor: '', Mandiri_2_univ: '', Mandiri_2_prodi: '', Mandiri_3_nomor: '', Mandiri_3_univ: '', Mandiri_3_prodi: '',
                        pembelajaran: '', sekolah_impian_1: '', sekolah_impian_2: '', sekolah_impian_3: ''
                    },
                    verified: {
                        patternID: '', branchClassID: '', secondPatternID: '', secondBranchClassID: '',thirdPatternID: '', thirdBranchClassID: '', fourthPatternID: '', fourthBranchClassID: '',payment: '', paymentNote: '', placement: '', intensiveScheduleID: '', intensiveClassID: ''
                    }
                },
                imagePreview: '',
                school: null,
                branchProgramID: '',
                branches: [],
                patterns: [],
                intensives: [],
                branchPrograms: [],
                grades: [],
                branchClasses: [],
                secondBranchClasses: [],
                thirdBranchClasses: [],
                fourthBranchClasses: [],
                intensiveClasses: [],
                schools: [],
                dateLanguage: id,
                semesters: semesters
            };
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                formData.set('student[termID]', this.term.id);
                this.axios.post(process.env.API_URL + '/student', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'student/view', params: {id: response.data.data.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.student.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            fetchBranches() {
                if (this.profile.isAdmin) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                } else if (this.profile.isEmployee) {
                    if (this.profile.employee.isBranchStaff) {
                        this.form.student.branchID = this.profile.employee.branchStaff.branchID;
                    }
                }
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            }
        },
        created() {
            this.fetchBranches();
            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/school')
            ]).then(this.axios.spread(function (responseGrade, responseSchool) {
                this.grades = responseGrade.data.data;
                this.schools = responseSchool.data.data;
            }.bind(this)));
        },
        mounted() {
            document.title = 'Add Student - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
</style>


// WEBPACK FOOTER //
// src/components/student/Add.vue